import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const fileNotesDocumentSvg = () => (
  <svg height={24} width={24} version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" x="0" y="0" xmlSpace="preserve">
    <g fill="none">
      <path id="Frame_-_24px" d="M0 0h24v24H0z" fill="none" />
      <g id="Line_Icons">
        <path d="M7 13h10v2H7z" fill="currentColor" />
        <path d="M7 9h8v2H7z" fill="currentColor" />
        <path d="M7 17h10v2H7z" fill="currentColor" />
        <path
          d="M19 2h-2V1a1 1 0 0 0-2 0v1h-2V1a1 1 0 0 0-2 0v1H9V1a1 1 0 0 0-2 0v1H5c-1.103 0-2 .896-2 2v18c0 1.103.897 2 2 2h14c1.103 0 2-.897
          2-2V4c0-1.104-.897-2-2-2zM5 22V4h2v1a1 1 0 1 0 2 0V4h2v1a1 1 0 1 0 2 0V4h2v1a1 1 0 1 0 2 0V4h2l.001 18H5z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

const fileNotesDocument = (props: IIconProps) => <Icon component={fileNotesDocumentSvg} {...props} />;

export default fileNotesDocument;
